import React, {useState} from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {Provider, useSelector} from 'react-redux';
import {RootState, store} from './app/store';
import BaseView from './components/BaseView';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Home from './pages/Home';
import {ConfigProvider} from "antd";
import NotFound from "./components/NotFound";
import TenantManager from "./components/TenantManager";
import trTR from 'antd/locale/tr_TR';
import ResetPasswordPage from "./pages/Users/ResetPasswordPage";
import LandingPage from "./pages/Landing/LandingPage";
import Dashboard from "./pages/Dashboard/Dashboard";

const App: React.FC = () => {
    const isAuthenticated = useSelector((state: RootState) => state.persisted?.isLoggedIn);
    const tenantInfo = useSelector((state: RootState) => state.persisted?.tenantInfo);

    // const [bg, setBg] = useState("#89A8B2")
    const themeConfig = useSelector((state: RootState) => state.app?.themeConfig);
    const DebugRouter = ({children}: { children: any }) => {
        const location = useLocation();
        if (process.env.NODE_ENV === 'development') {
            console.log(
                `Route: ${location.pathname}${location.search}, State: ${JSON.stringify(location.state)}`,
            )
        }

        return children
    }

    const isTenantValid = (id: string) => {
        if (tenantInfo) {
            return tenantInfo.id === id
        }
        return false;
    }

    return (
        <Router>
            <TenantManager>
                <ConfigProvider
                    locale={trTR}
                    theme={themeConfig}
                >
                    <BaseView>
                        <DebugRouter>

                            <Switch>
                                {/* 1) Public Landing */}
                                <Route exact path="/" component={LandingPage}/>

                                {/* 2) Şifre sıfırlama */}
                                <Route exact path="/:id/resetpassword/:token" component={ResetPasswordPage}/>

                                {/* 3) Login */}
                                <Route
                                    exact
                                    path="/:id/login"
                                    render={({match}) => {
                                        const {id} = match.params as { id: string };
                                        if (!isTenantValid(id)) return <Redirect to="/404"/>;
                                        return <Login/>;
                                    }}
                                />

                                {/* 4) 404 */}
                                <Route exact path="/404" component={NotFound}/>

                                {/* 5) /:id → önce ID geçerli mi? sonra login mi? */}
                                <Route
                                    exact
                                    path="/:id"
                                    render={({match}) => {
                                        const {id} = match.params as { id: string };
                                        if (!isTenantValid(id)) {
                                            return <Redirect to="/404"/>;
                                        }
                                        return isAuthenticated
                                            ? <Home/>
                                            : <Redirect to={`/${id}/login`}/>;
                                    }}
                                />


                                {/* 6) Gelen tüm /:id/... isteği için Home (Protected) */}
                                <Route path="/:id"
                                       render={(props) =>
                                           isAuthenticated
                                               ? <Home/>
                                               : <Redirect to={`/${(props.match.params as any).id}/login`}/>
                                       }/>

                                {/* 7) * */}
                                <Route path="*" component={NotFound}/>

                            </Switch>

                        </DebugRouter>
                    </BaseView>
                </ConfigProvider>
            </TenantManager>
        </Router>
    );
};

export default App;
